import { useEffect, useState } from 'react';
import { FieldConfig } from '../../../../../components/CustomFormsComponents/CustomField';
import { CONTRACTOR_BUSINESS_TYPES } from '../consts';
import { useAppSelector } from '../../../../../hooks/reduxHooks';
import { TEST_IDS } from '../testIds';

const useContractorFieldsConfig = ({ t, formData, handleBlurValidation }: any) => {
    const [contractorFieldsConfig, setContractorFieldsConfig] = useState<FieldConfig[]>([]);
    
    const ciiuCodes = useAppSelector(
        (state) => state?.carcinogenicReport?.ciiuCodes
    );

    useEffect(() => {
        const fieldsConfig: FieldConfig[] = [
            {
                type: 'text',
                label: t('responsiblesAndContractorsForms.newContractor.inputs.cuit') as string,
                name: 'cuit',
                required: true,
                value: formData.cuit,
                disabled: false,
                helperText: t(
                    'responsiblesAndContractorsForms.newContractor.inputs.cuit'
                ) as string,
                onBlurValidation: handleBlurValidation,
                inputType: 'number',
                maxLength: 11,
                minLength: 11,
                gridSpace: { xs: 12 },
                testID: TEST_IDS.contractors.newContractorFormFields.cuit,
                validations: [{ name: 'required' }, { name: 'fixedLength', param: 11 }]
            },
            {
                type: 'autocomplete',
                label: t(
                    'responsiblesAndContractorsForms.newContractor.inputs.companyActivity'
                ) as string,
                name: 'companyActivity',
                required: true,
                value: formData.companyActivity,
                options: ciiuCodes?.data?.codigos || [],
                getOptionLabel: (item: any) => {
                    const codigo = item?.codigo || '';
                    const descripcion = item?.descripcion || '';
                    return codigo && descripcion ? `${codigo} - ${descripcion}` : '';
                },
                gridSpace: { xs: 12 },
                onBlurValidation: handleBlurValidation,
                testID: TEST_IDS.contractors.newContractorFormFields.companyActivity,
                validations: [{ name: 'required' }]
            },
            {
                type: 'autocomplete-default',
                label: t(
                    'responsiblesAndContractorsForms.newContractor.inputs.companyType'
                ) as string,
                name: 'companyType',
                required: true,
                value: formData.companyType,
                disabled: false,
                gridSpace: { xs: 12 },
                options: CONTRACTOR_BUSINESS_TYPES || [],
                onBlurValidation: handleBlurValidation,
                testID: TEST_IDS.contractors.newContractorFormFields.companyType,
                validations: [{ name: 'required' }]
            },
            {
                type: 'text',
                label: t(
                    'responsiblesAndContractorsForms.newContractor.inputs.employeeQuantity'
                ) as string,
                name: 'employeeQuantity',
                required: true,
                value: formData.employeeQuantity,
                disabled: false,
                inputType: 'number',
                gridSpace: { xs: 12 },
                onBlurValidation: handleBlurValidation,
                testID: TEST_IDS.contractors.newContractorFormFields.employeeQuantity,
                validations: [{ name: 'required' }, { name: 'minValue', param: 0 }]
            }
        ];

        setContractorFieldsConfig(fieldsConfig);
    }, [t, ciiuCodes]);

    return {
        contractorFieldsConfig
    };
};

export default useContractorFieldsConfig;
